<template>
  <section class="content-section section">
    <div class="container">
      <div class="content-layout" :class="{ 'reverse': reverse }">
        <div class="content-image">
          <v-lazy-image :src="image" :alt="title" />
        </div>
        <div class="content-text">
          <h2 class="section-title">{{ title }}</h2>
          <p v-for="(line, index) in descriptionLines" :key="index" class="text-item">{{ line }}</p>
          <button class="btn btn-primary" @click="goToDownload">{{ $config.content_section.download_button }}</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentSection',
  props: {
    title: String,
    description: String,
    image: String,
    reverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    descriptionLines() {
      return this.description ? this.description.split('\n') : []
    }
  },
  methods: {
    goToDownload() {
      this.$router.push('/download');
    }
  }
}
</script>

<style scoped>
.section {
  padding: 40px 0;
}
.content-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  align-items: center;
}
.content-layout.reverse .content-image {
  order: 2;
}
.content-image {
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 8px;
  overflow: hidden;
}
.content-text {
  max-width: 450px;
  text-align: left;
}
.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #1A202C;
  margin-bottom: 24px;
}
.content-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.text-item {
  font-size: 16px;
  color: #5A6672;
  margin-bottom: 12px;
  line-height: 1.6;
}
.content-text .btn {
  margin-top: 30px;
  background-color: #003354;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

@media (max-width: 768px) {
  .content-layout, .content-layout.reverse {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .content-layout.reverse .content-image {
    order: 0;
  }
  .content-text {
    margin: 0 auto;
  }
}
</style>